<template>
  <div class="text-center">
    <primary-insights :account="account" />
    <secondary-insights v-if="showMore" :account-id="account.id" class="q-my-md" />
    <q-btn
      :label="showMore ? 'View Less Insights' : 'View More Insights'"
      :icon-right="showMore ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
      color="grey-2"
      text-color="dark"
      rounded
      unelevated
      no-caps
      @click="showMore = !showMore"
      class="q-my-lg"
    />
    <div v-if="account.postsUntil" class="q-mt-sm">
      <posts-last-imported
        v-if="account.postsUntil"
        :time="account.postsUntil"
        class="text-body1 text-italic"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/social/types';
import PostsLastImported from '@/social/post/import/status/PostsLastImported.vue';
import PrimaryInsights from './PrimaryInsights.vue';
import SecondaryInsights from './SecondaryInsights.vue';

interface Data {
  showMore: boolean
}

export default defineComponent({
  components: {
    PrimaryInsights,
    PostsLastImported,
    SecondaryInsights,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      showMore: false,
    };
  },
});
</script>
